import e, { forwardRef as s } from "react";
import { ark as i } from "@ark-ui/react/factory";
import { styled as t } from "@huspy/styled-system/jsx";
import { spinner as p } from "@huspy/styled-system/recipes";
const c = t(i.div, p), f = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`, d = s((o, n) => {
  const { label: r = "Loading...", color: a, size: l, ...m } = o;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("style", null, f), /* @__PURE__ */ e.createElement(
    c,
    {
      ref: n,
      color: a,
      size: l,
      borderLeftColor: "alpha-black-40",
      borderBottomColor: "alpha-black-40",
      ...m
    },
    r && /* @__PURE__ */ e.createElement(t.span, { srOnly: !0 }, r)
  ));
});
d.displayName = "Spinner";
export {
  d as Spinner,
  c as StyledSpinner
};
